import { setTerm } from './helpers';

export const setIsByCommercialOwner = setTerm('is_by_commercial_owner');
